import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=a7b67fb0&"
import script from "./estadisticas.vue?vue&type=script&lang=js&"
export * from "./estadisticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports